export { default } from "./Card3x1"
